import { get } from '@/utils/request'

export function getSiteConfig() {
  return get('/portal/site-config').then(res => res.data || {})
}

export function getHomeData() {
  return get('/portal/home').then(res => res.data || {})
}

export function getProfile() {
  return get('/portal/profile').then(res => res.data || {})
}

export function getCultureList() {
  return get('/portal/culture/list').then(res => res.data || [])
}

export function getHonorList(params) {
  return get('/portal/honor/list', params).then(res => res.rows || [])
}

export function getOrgList() {
  return get('/portal/org/list').then(res => res.data || [])
}

export function getNewsList(params) {
  return get('/portal/news/list', params).then(res => ({
    rows: res.rows || [],
    total: res.total || 0
  }))
}

export function getNewsDetail(id) {
  return get(`/portal/news/${id}`).then(res => res.data || {})
}

export function getCaseList(params) {
  return get('/portal/case/list', params).then(res => ({
    rows: res.rows || [],
    total: res.total || 0
  }))
}

export function getCaseDetail(id) {
  return get(`/portal/case/${id}`).then(res => res.data || {})
}

export function getCaseCategoryList() {
  return get('/portal/case-category/list').then(res => res.data || [])
}

export function getCultureArticleList(params) {
  return get('/portal/culture-article/list', params).then(res => ({
    rows: res.rows || [],
    total: res.total || 0
  }))
}

export function getCultureArticleDetail(id) {
  return get(`/portal/culture-article/${id}`).then(res => res.data || {})
}

export function getPartyArticleList(params) {
  return get('/portal/party/list', params).then(res => ({
    rows: res.rows || [],
    total: res.total || 0
  }))
}

export function getPartyArticleDetail(id) {
  return get(`/portal/party/${id}`).then(res => res.data || {})
}

export function getContact() {
  return get('/portal/contact').then(res => res.data || {})
}
